import React, { useState, useEffect, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { Button, Grid } from '@material-ui/core';
import pdf from '../../../assets/images/pdf.png';

import './style.css';

function Filter({ dateFilter, handleFilter, handleExportToPDF }) {
  const CustomInputDate = forwardRef(({ value, onClick }, ref) => (
    <button className="custom-date-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  const moveLeft = () => {
    const newDate = new Date(dateFilter);
    handleFilter(newDate.setMonth(newDate.getMonth() - 1));
  };

  const moveRigth = () => {
    const newDate = new Date(dateFilter);
    handleFilter(newDate.setMonth(newDate.getMonth() + 1));
  };

  const updateFilter = (newDate) => {
    handleFilter(new Date(newDate));
  };

  const exportDataToPDF = () => {
    handleExportToPDF(dateFilter);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={11}>
          <div style={{ display: 'flex' }}>
            <div className="schedule-input" style={{ display: 'flex', margin: '8px' }}>
              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px', paddingLeft: '20px' }}
                onClick={() => moveLeft()}
              >
                🢀
              </Button>

              <DatePicker
                selected={dateFilter}
                onChange={(date) => {
                  updateFilter(date);
                }}
                showMonthYearPicker
                dateFormat={'MMMM/yyyy'}
                locale="ptBR"
                customInput={<CustomInputDate />}
                readOnly
              />

              <Button
                style={{ minWidth: '20px', width: '20px', height: '23px' }}
                onClick={() => moveRigth()}
              >
                🢂
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={1}>
          <img
            src={pdf}
            onClick={() => exportDataToPDF()}
            style={{ cursor: 'pointer', maxHeight: '50px' }}
          ></img>
        </Grid>
      </Grid>
    </>
  );
}

export default Filter;
